import Card from '../../../ui/card';
import {useForm} from 'react-hook-form';
import Input from '../../../ui/input';
import Button from '../../../ui/button';
import {FormControlLabel, Radio, RadioGroup} from '@mui/material';
import {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import api from '../../../../Interceptor';
import ModalFooter from '../../../customModal/modalFooter';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Packages = ({ onClose }) => {
  const [packages, setPackages] = useState([]);
  useEffect(() => {
    const getAllPackages = async () => {
      try {
        const {data: packages} = await api.get(
          `${API_BASE_URL}/api/v1/admin/paymentPlan`
        );
        setPackages(packages);
      } catch (error) {
        toast.error('Failed to fetch packages');
        console.error(error);
      }
    };

    getAllPackages();
  }, []);
  const {handleSubmit, control, watch, setValue} = useForm({
    defaultValues: {package: 'Basic'},
  });
  const onSubmit = async (data) => {
    try {
      const selectedPackage = packages.find((pkg) => pkg.name === data.package);

      if (!selectedPackage) {
        toast.error('Invalid package selected');
        return;
      }

      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/admin/payment/create`,
        {id: selectedPackage.id}
      );

      const {message} = response.data;

      if (message) {
        window.location.href = message;
      } else {
        toast.error('Payment URL not received');
      }
    } catch (err) {
      toast.error('Payment creation failed');
      console.error(err);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h1 className="mb-2 text-gray-800 font-semibold">
        Select your payment plan!
      </h1>
      <RadioGroup
        defaultValue={watch('package')}
        onChange={(e) => {
          setValue('package', e.target.value);
        }}
      >
        <div className="flex gap-4 justify-center">
          {packages.map((pkg) => (
            <Card
              className="flex flex-col gap-2 py-5 px-3 w-1/3 rounded-lg"
              key={pkg._id}
            >
              <span className="flex items-center text-gray-600">
                <Input
                  control={control}
                  type="radio"
                  name="package"
                  value={pkg.name}
                >
                  <FormControlLabel
                    value={pkg.name}
                    control={<Radio size="small" />}
                  />
                </Input>

                <p className="font-semibold text-base text-gray-600 capitalize">
                  {pkg.name}
                </p>
              </span>
              <p className="text-sm">{pkg.description}</p>
            </Card>
          ))}
        </div>
      </RadioGroup>
      <ModalFooter onCancel={onClose} />
    </form>
  );
};

export default Packages;
